import {FiPlus} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {CheckInfo} from "@/lib/queries/statuspages.ts";
import {MetricsExplorerSchema} from "@/lib/types/metricsExplorer.ts";
import {ExplorerConfig, ExplorerSeriesConfig} from "@/pages/metricsExplorer/explorerConfig.ts";
import {uniqueCheckTypes} from "@/pages/metricsExplorer/schemaUtils.ts";
import {SeriesSpecRow} from "@/pages/metricsExplorer/seriesBuilder/SeriesSpecRow.tsx";

import styles from "./SeriesBuilderRail.module.scss";

interface SeriesBuilderRailProps {
  config: ExplorerConfig;
  schema: MetricsExplorerSchema | undefined;
  checkMeta: Record<number, CheckInfo>;
  start: Date;
  end: Date;
  onUpdateSeries: (ref: string, patch: Partial<ExplorerSeriesConfig>) => void;
  onAddSeries: () => void;
  onRemoveSeries: (ref: string) => void;
  onDuplicateSeries: (ref: string) => void;
  onChecksResolved: (checks: CheckInfo[]) => void;
}

export const SeriesBuilderRail = ({
  config,
  schema,
  checkMeta,
  start,
  end,
  onUpdateSeries,
  onAddSeries,
  onRemoveSeries,
  onDuplicateSeries,
  onChecksResolved,
}: SeriesBuilderRailProps) => (
  <div className={styles.rail}>
    <span className={styles.heading}>Series</span>
    {config.series.map((series, index) => (
      <SeriesSpecRow
        key={series.ref}
        index={index}
        series={series}
        schema={schema}
        checkTypes={uniqueCheckTypes(
          series.checkIds.map((id) => checkMeta[id]?.monitoring_service_type).filter((type): type is string => !!type)
        )}
        start={start}
        end={end}
        onChange={(patch) => onUpdateSeries(series.ref, patch)}
        onRemove={() => onRemoveSeries(series.ref)}
        onDuplicate={() => onDuplicateSeries(series.ref)}
        onChecksResolved={onChecksResolved}
      />
    ))}
    <div>
      <Button variant="secondary" size="small" onClick={onAddSeries}>
        <Icon icon={FiPlus} /> Add series
      </Button>
    </div>
  </div>
);
